import {
    AgGridColumnDef,
    AgGridFilterType,
    FilterOption,
    SortOption
} from '@tassat/common-definitions';

import { caseInsensitiveSort } from 'Lib/stringHelpers';
import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';
import ClientUserRenderer from 'SharedComponents/cellRenderComponent/clientUserCellRenderer';

import { GridUserData } from '.';

export const cellHeight = 74;

const didUserUpdate = (userA: GridUserData, userB: GridUserData) => {
    if (!userA) {
        return !userB;
    } else {
        return userA.UserId === userB.UserId &&
            userA.FirstName === userB.FirstName &&
            userA.LastName === userB.LastName &&
            userA.Email === userB.Email &&
            userA.IsTokenAPIUser === userB.IsTokenAPIUser &&
            userA.IsLocked === userB.IsLocked &&
            userA.IsFrozen === userB.IsFrozen &&
            userA.HasApiConnections === userB.HasApiConnections;
    }
};

export const getFirmUsersColumnDefs = (isSSOEnabled): AgGridColumnDef[] => {
    return [
        {
            field: '',
            headerName: '',
            cellRenderer: ClientUserRenderer,
            cellRendererParams: {
                cellHeight: cellHeight,
                isSSOEnabled: isSSOEnabled
            },
            valueGetter: ({ data }) => data,
            equals: didUserUpdate,
            menuTabs: [],
            flex: 1
        },
        {
            field: 'IsTokenAPIUser',
            colId: 'IsTokenAPIUser',
            filter: 'agTextColumnFilter',
            hide: true,
            menuTabs: []
        },
        {
            field: 'IsFrozen',
            colId: 'IsFrozen',
            filter: 'agTextColumnFilter',
            hide: true,
            menuTabs: []
        },
        {
            field: 'IsLocked',
            colId: 'IsLocked',
            filter: 'agTextColumnFilter',
            hide: true,
            menuTabs: []
        },
        {
            field: '',
            colId: 'UserName',
            filter: 'agTextColumnFilter',
            valueGetter: ({ data }) => `${data.FirstName} ${data.LastName}`,
            comparator: caseInsensitiveSort,
            hide: true,
            menuTabs: []
        },
        {
            field: 'Username',
            colId: 'Username',
            filter: 'agTextColumnFilter',
            comparator: caseInsensitiveSort,
            hide: true,
            menuTabs: []
        }
    ];
};
export const getClientUserFilterOptions = (muiTheme: ApplicationMuiTheme): FilterOption[] => {
    const clientUserFilterOptions: FilterOption[] = [
        {
            title: 'Token API Users',
            colId: 'IsTokenAPIUser',
            type: AgGridFilterType.Equal,
            filter: 'true'
        },
        {
            title: 'Frozen Users',
            colId: 'IsFrozen',
            type: AgGridFilterType.Equal,
            filter: 'true'
        },
        {
            title: 'Locked Users',
            colId: 'IsLocked',
            type: AgGridFilterType.Equal,
            filter: 'true'
        },
        {
            title: 'Clear Filter',
            colId: 'clear',
            type: AgGridFilterType.ClearFilter,
            filter: 'clear'
        }
    ];

    return clientUserFilterOptions;
};

export const clientUserSortOptions: SortOption[] = [
    {
        title: 'User Name',
        colId: 'UserName'
    },
    {
        title: 'Username',
        colId: 'Username'
    },
    {
        title: 'Locked',
        colId: 'IsLocked'
    },
    {
        title: 'Frozen',
        colId: 'IsFrozen'
    },
    {
        title: 'Clear Sort',
        colId: 'clear'
    }
];